import { Environment } from './environment.type';

export const environment: Environment = {
  appBaseUrl: 'https://dashboard.adv-slstst.momentum.co.za',
  connectCrmApiUrl: 'https://connect-crm.adv-slspre.momentum.co.za/connect-crm',
  permissionsServiceUrl: 'https://permissions.adv-slstst.momentum.co.za/permissions/v1',
  remoteAssetBaseUrl: 'https://dashboard.adv-slstst.momentum.co.za',
  allowMockData: true,
};
